import { render, staticRenderFns } from "./OrderBoxLocal.vue?vue&type=template&id=8a2bf104&scoped=true&"
import script from "./OrderBoxLocal.vue?vue&type=script&lang=js&"
export * from "./OrderBoxLocal.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoxLocal.vue?vue&type=style&index=0&id=8a2bf104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2bf104",
  null
  
)

export default component.exports